import type {
  IGenerationStatusPayload,
  IPatientSummary,
  IPatientSummaryGenerationStatus,
} from "../hexagon/core/ports/driver/VisitNotesService";

export const PATIENT_SUMMARY_RUNNING_POLL_MS = 2_000;

type PatientSummaryStatusLike =
  | {
      generation_status?: IGenerationStatusPayload;
      status?: string | null;
    }
  | null
  | undefined;

export function isPatientSummaryStatusLikeRunning(
  value: PatientSummaryStatusLike
): boolean {
  const rawStatus = value?.generation_status ?? value?.status ?? null;
  if (typeof rawStatus === "string") return rawStatus === "running";
  if (!rawStatus || typeof rawStatus !== "object") return false;
  return (
    rawStatus.status === "running" || rawStatus.generation_status === "running"
  );
}

export function isPatientSummaryGenerationRunning(
  summary: IPatientSummary | null | undefined
): boolean {
  return isPatientSummaryStatusLikeRunning(summary);
}

export function isPatientSummaryStatusRunning(
  status: IPatientSummaryGenerationStatus | null | undefined
): boolean {
  return isPatientSummaryStatusLikeRunning(status);
}

export function buildRunningPatientSummary(
  status: IPatientSummaryGenerationStatus,
  patientId: number
): IPatientSummary {
  return {
    patient_id: status.patient_id ?? patientId,
    patient_summary: null,
    has_visit_context: false,
    generated_at: null,
    generated_by: null,
    exists: false,
    clinical_risk: null,
    generation_status: status.generation_status ?? status.status ?? "running",
  };
}
